var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasData
    ? _c(
        "div",
        [
          _c(
            "v-list-tile",
            { staticClass: "v-list--two-line" },
            [
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLast ? _c("v-divider") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }